var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed flex items-center justify-center",staticStyle:{"background":"rgba(0, 0, 0, .5)","width":"100%","height":"100%","top":"0","left":"0","z-index":"9999"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }